<template>
    <div class="modal ver2 show" id="salesDetails_popup">
        <div class="modal_box">
            <div class="modal_head inner">
                <div class="h_left"></div>
                <div class="h_title">결제내역 상세보기</div>
                <div class="h_right">
                    <button type="button" class="btn clear_btn close_btn"
                        @click="$emit('paymentDetailModalClose')"></button>
                </div>
            </div>
            <div class="modal_body inner">
                <div class="tbl_wrap">
                    <div class="tbl_titbox">
                        <p class="tit">
                            결제 상세 내역을 보실 수 있습니다.
                        </p>
                    </div>
                    <table class="tbl modal_ver">
                        <thead>
                            <tr>
                                <th>결제일</th>
                                <th>계정</th>
                                <th>항목</th>
                                <th>금액</th>
                                <th>결제방법</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="date">{{ props.paymentDetail.pay_date }}</td>
                                <td class="email">{{ props.paymentDetail.email }}</td>
                                <td class="tit">{{ props.paymentDetail.type == 0 ? 'Basic Plan' : 'Pro Plan' }} 구매</td>
                                <td class="price">
                                    <span class="bold">{{ props.paymentDetail.pricing }}</span>
                                </td>
                                <td class="method">
                                    <span class="badge_icon">
                                        <img :src="props.paymentDetail.pay_method == 1 ? `${proxy.$STATIC_URL}/admin/img/badge_googleplay.png` : `${proxy.$STATIC_URL}/admin/img/badge_appstore.png`"
                                            alt="" class="icon">
                                        <span class="txt">{{ props.paymentDetail.pay_method == 1 ? '구글플레이' :
                                            '앱스토어' }}</span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tbl_wrap">
                    <div class="tbl_titbox">
                        <p class="tit">
                            결제 내용
                        </p>
                    </div>
                    <div class="tbl_box">
                        <div class="item">
                            <p class="tit">결과 메시지</p>
                            <p class="desc">
                                {{ props.paymentDetail.status == 1 ? '정상 결제가 되었습니다.' : '결제 취소가 되었습니다.' }}
                            </p>
                        </div>
                        <div class="item wid50 left">
                            <p class="tit">주문번호</p>
                            <p class="desc">{{ props.paymentDetail.pid }}</p>
                        </div>
                        <div class="item wid50 right">
                            <p class="tit">거래번호</p>
                            <p class="desc">{{ props.paymentDetail.pay_method == 1 ?
                                JSON.parse(props.paymentDetail.order_id).orderId : props.paymentDetail.order_id }}</p>
                        </div>
                        <div class="item wid50 left last">
                            <p class="tit">결제금액</p>
                            <p class="desc bold">{{ props.paymentDetail.pricing }}</p>
                        </div>
                        <div class="item wid50 right last">
                            <p class="tit">취소일</p>
                            <p class="desc">{{ props.paymentDetail.refund_date }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal_foot" v-if="props.paymentDetail.status == 1 && props.paymentDetail.pay_method == 1">
                <button type="button" class="btn" @click="reqCancelPayment">결제 취소</button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, getCurrentInstance } from 'vue';
import { cancelPayment } from '@/api';
const { proxy } = getCurrentInstance();
// const emit = defineEmits(['paymentDetailModalClose']);

const props = defineProps({
    paymentDetail: {
        type: Object,
        default: () => ({})
    }
})
const reqCancelPayment = async () => {
    const data = {
        pid: props.paymentDetail.pid,
        order_id: props.paymentDetail.pay_method == 1 ? JSON.parse(props.paymentDetail.order_id).orderId : props.paymentDetail.order_id
    }
    await cancelPayment(data);
    location.reload();
}
</script>
